import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import CKEditor from 'ckeditor4-vue';
import ImageHotspot from 'vue-img-hotspot';

Vue.config.productionTip = false

Vue.use( CKEditor );
Vue.use( ImageHotspot );

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
